import domWrap from './domWrap';
import h from './htm';

const scrollNav = element => {
	const nav = domWrap(element);
	let wrap;
	if(!nav.classList.contains('scroll')){
		nav
			.css({height:nav.querySelector(':scope > *').offsetHeight+'px'})
			.wrapInner(h('div wrap').Node)
			.classList.add('scroll');

		wrap = domWrap(nav.querySelector('[wrap]'));

		nav.appendChild(h('div control class="left"')('div control class="right"').Node);
		nav.on('click', '[control]', function(){
			wrap.scroll({
				left: wrap.scrollLeft - (wrap.querySelector(':scope > *')?.offsetWidth * (this.classList.contains('left') ? 1 : -1)), 
				behavior: 'smooth' 
			});
		});
		wrap.addEventListener('scroll',checkFlow);
		window.addEventListener('resize',checkFlow);
		checkFlow();
	}
	function checkFlow(){
		nav.classList.toggle('left',wrap.check.overflowLeft)
		nav.classList.toggle('right',wrap.check.overflowRight);
	}
	return nav;
};

export default scrollNav;